module.exports = __webpack_public_path__ + "img/arrow.470811d.svg";